import { useRouter } from "next/router";
import styled from "styled-components";
import { Section, Container, Row, Columns } from "../../styles/commonStyles";
import Button from "../Buttons/Button";
import { mediaMaxWidth } from "../../utils/mediaQuery";
import config from "../../config";
import Mixpanel from "../../utils/Mixpanel";
import { getUrlPath } from "../../utils/helpers";
import { CLOUDINARY_BASE_URL } from "../../utils/constants";

const CTABanner = ({ id, source }) => {
	const router = useRouter();

	const trackPostJobClick = () => {
		Mixpanel.track("Post A Job Click", {
			Source: source,
			page: getUrlPath(),
		});
	};

	const trackEmployerLoginClick = () => {
		Mixpanel.track("Employer Login Click", {
			Source: source,
			medium: "CTA",
			page: getUrlPath(),
		});
	};

	return (
		<SectionContainer bgColor="#83bde4" id={id}>
			<Container>
				<Row>
					<Columns>
						<HeadingDesktopView>
							<HeadingMainText>I am looking to hire staff</HeadingMainText>
							<HeadingSubText>
								Get a hire for your company within 48 hours
							</HeadingSubText>
						</HeadingDesktopView>
						<Heading>If you are an employer, post your job</Heading>
					</Columns>
					<Columns>
						<ButtonGroup>
							{/* <Button secondary as="a">How it works?</Button> */}
							{/* <Button as="a" href="https://apnaapp.typeform.com/to/R2iNgW" id="cta-banner-job-typeform-btn" target="_blank" rel="noopener noreferrer">Post a Job now</Button> */}
							<Button
								as="a"
								href={`${config.dashboardUrl}/login?utm_source=${
									(router.query && router.query.utm_source) || "Website"
								}&utm_medium=${
									(router.query && router.query.utm_medium) ||
									"Post%20Job%20Button"
								}&utm_campaign=${
									(router.query && router.query.utm_campaign) ||
									"Website"
								}&employer=true`}
								id="cta-banner-job-typeform-btn"
								target="_blank"
								rel="noopener noreferrer"
								onClick={trackPostJobClick}
							>
								Post a Job now
							</Button>
							<Button
								secondary
								as="a"
								href={`${config.dashboardUrl}/login?utm_source=${
									(router.query && router.query.utm_source) || "Website"
								}&utm_medium=${
									(router.query && router.query.utm_medium) ||
									"Employer%20Login%20Button"
								}&utm_campaign=${
									(router.query && router.query.utm_campaign) ||
									"Website"
								}&employer=true`}
								id="cta-banner-employer-portal-btn"
								target="_blank"
								rel="noopener noreferrer"
								onClick={trackEmployerLoginClick}
							>
								Employer Login
							</Button>
						</ButtonGroup>
					</Columns>
				</Row>
			</Container>
		</SectionContainer>
	);
};

// Styles
const Heading = styled.h3`
	font-size: 24px;
	font-weight: normal;
	line-height: 1.83;
	color: #ffffff;
	margin-bottom: 0;
	display: none;

	${mediaMaxWidth.large`
		display: block;
        font-size: 14px;
    `};
`;
const HeadingDesktopView = styled.div`
	${mediaMaxWidth.large`
		display: none;
	`}
`;
const HeadingMainText = styled.h3`
	font-size: 32px;
	font-weight: 900;
	line-height: 1.38;
	color: #ffffff;
	margin-bottom: 5px;
`;
const HeadingSubText = styled.p`
	font-size: 20px;
	line-height: 1.45;
	color: #ffffff;
	margin-bottom: 0;
`;
const ButtonGroup = styled.div`
	& ${Button} {
		display: inline-block;
		line-height: 55px;
		text-decoration: none;
		background-color: #4d3951;
	}
	& ${Button}:last-child {
		color: #fff;
		border-color: #fff;
		background-color: transparent;

		&:hover {
			border-color: #fff;
		}
	}
	& ${Button}:first-child {
		margin-right: 20px;
	}
	${mediaMaxWidth.large`
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 12px;
		margin: 10px 0;
        & ${Button} {          
            height: 40px;
            text-decoration: none;
            font-size: 12px;
			padding: 0 10px;
			line-height: 40px;
			background-color: #4d3951;
        }
        & ${Button}:last-child {
            background-color: transparent;
            border: 1px solid #fff;
			&:hover {
				border-color: #fff;
			}
        }
    `};
	${mediaMaxWidth.extraExtraSmall`
        flex-wrap: wrap;
        & ${Button}:first-child {
            margin-right: 0;
        }
    `}
`;
const SectionContainer = styled(Section)`
	${"" /* padding: 45px 0; */}
	position: relative;
	overflow: hidden;

	&#cta-banner-desktop-view {
		display: block;
	}
	&#cta-banner-mobile-view {
		display: none;
	}

	& ${Container} {
		background-image: url(${CLOUDINARY_BASE_URL}/employer.png);
		background-repeat: no-repeat;
		background-position: left bottom;
		padding: 45px 0 45px 127px;
	}

	${mediaMaxWidth.large`
		& ${Container} {
			background-image: none;
			padding: 10px 15px;
		}
        &#cta-banner-mobile-view {
            display:block;
        }
        &#cta-banner-desktop-view {
            display:none;
        }
        
        position: sticky;
        top: 0;
        z-index: 101;
        & ${Row} {
            flex-wrap: wrap;
        }
        & ${Heading}, & ${ButtonGroup} {
            text-align: center;
        }
    `}
`;
export default CTABanner;
